export const parseBoolean = (value: string | undefined) => {
  return value === 'true';
};
